import MembershipBuyButton from './components/MembershipBuyButton/widget.svelte';

var div = document.getElementById('cobraticket-membership-buy-button');

let embed;
if (div) {
	var script = document.currentScript;
	var attributes: any = {};
	if (script) {
		script.parentNode?.appendChild(script);
		for (var i = 0; i < script.attributes.length; i++) {
			var attr = script.attributes[i];
			attributes[attr.name] = attr.value;
		}
	}
	console.log('attributes', attributes);
	embed = new MembershipBuyButton({
		target: div,
		props: {
			publicKey: attributes['public-key'],
			primaryColor: attributes['primary-color'],
			buttonText: attributes['button-text'],
			membershipCode: attributes['membership-code']
		}
	});
}
export default embed;
